import React from 'react'

import decryptJWT from '../../utils/decryptJWT'

export const TituloBotaoColunas = ({ titulo }) => (
  <div className="fonte-cor-1 nao-selecionavel label-titulo-botao-colunas">
    {titulo}
  </div>
)

export const TrianguloPersonalizar = () => (
  <div className="triangulo-personalizar" />
)

export function ListaColunasCategoria({
  listaCategoria,
  categoriaKey,
  handlerChangeSwitich,
  isFaturas = false
}) {
  return (
    <div className="container-switches-exibir-colunas">
      {listaCategoria?.map((item, idx) => (
        <React.Fragment key={item.id}>
          {(isFaturas || item.nivel_acesso >= decryptJWT('clienteNivel')) && (
            <ItemColunasCategoria
              item={listaCategoria[idx]}
              categoriaKey={categoriaKey}
              handlerChangeSwitich={handlerChangeSwitich}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  )
}

export function ListaColunasCategoriaFatura(props) {
  return <ListaColunasCategoria {...props} isFaturas />
}

export function ItemColunasCategoria({
  item,
  categoriaKey,
  handlerChangeSwitich
}) {
  const { id, nome, valor } = item

  return (
    <div
      className="grupo-switches-exibir-colunas"
      key={`${categoriaKey}-${id}`}
    >
      <div className="coluna-switches-exibir-colunas-1">
        <div className="flipswitch-medium">
          <input
            type="checkbox"
            checked={valor}
            className="flipswitch-medium-cb"
            id={id}
            onChange={(e) =>
              handlerChangeSwitich(e.target.id, categoriaKey, e.target.checked)
            }
          />
          <label className="flipswitch-medium-label" htmlFor={id}>
            <div className="flipswitch-medium-inner" />
            <div className="flipswitch-medium-switch" />
          </label>
        </div>
      </div>
      <div className="coluna-switches-exibir-colunas-2">
        <div className="label-switch-exibir-coluna fonte-cor-1">{nome}</div>
      </div>
    </div>
  )
}
